module.exports = {
  label: {
    contactDetail: 'Contact Details',
    contactNumber: 'Contact Number',
    notRegistered: 'You are not a registered doctor, please contact our team to get you started.',
    email: 'Email',
    button: {
      back: 'Back to login',
      home: 'Home'
    }
  }
};